import {Platform} from "vtom-api-typescript-client";

export class ArtifactPlatformUtil {
    static toLabelCode(value: Platform): string {
        return 'platform.' + value.toLowerCase();
    }
}
